import React, { useRef, useEffect, useState } from "react";
import { useStateValue } from "../SharedContext";
import { getTextColor } from "../../utils/utils";
import Glide from "@glidejs/glide";
import PropTypes from "prop-types";
import get from "lodash.get";

import "./glide.m.css";
const GlideBase = (props) => {
  const config = useStateValue() || {};
  const textColor = getTextColor(config.theme);
  const { slideIndicator: slideIndicator = "none", navigationArrows: arrow = true } = config;
  const startAt = get(props, ["options", "startAt"], 0);
  const [currentSlide, currentSlideHandler] = useState(startAt);
  const glideRef = useRef(null);
  const glideInstanceRef = useRef(null);

  const goToSlide = (index, glide) => glide && glide.go(`=${index}`);

  const sliderConfigOptions = {
    currentSlide: currentSlide
  };

  useEffect(() => {
    glideInstanceRef.current = initializeGlide(props, glideRef, currentSlideHandler);
  }, []);
  useEffect(() => () => destroyGlide(props, glideInstanceRef.current), []);
  const initializeGlide = (props, glideRef) => {
    const {
      children,
      perView = 1,
      autoplay = 5000,
      arrow = false,
      dot = true,
      gap = 10,
      animationDuration = 2000,
      breakpoints
    } = props;

    const glide = new Glide(glideRef.current, {
      type: "carousel",
      arrow,
      dot,
      perView,
      autoplay,
      gap,
      animationDuration,
      breakpoints
    });

    glide.on(["mount.after", "move.after"], () => {
      currentSlideHandler(glide.index);
    });

    if (children.length && glideRef) {
      glide.mount();
      return glide;
    }
    return null;
  };
  const destroyGlide = ({ children }, glide) => children && glide && glide.destroy();
  // storycard
  const renderChildren = ({ children }) =>
    children.map((child, storyIndex) => (
      <li key={storyIndex} className="glide__slide">
        {child}
      </li>
    ));
  // arrow
  const isArrowenable = !arrow ? "disable-arrow" : "";
  const activeSlide = sliderConfigOptions.currentSlide;
  const firstSlideHandler = activeSlide === 0 ? "disable-arrow-left" : "";
  const arrowNavigation = () => {
    return (
      <>
        <button
          className={`glide__arrow glide__arrow--left ${firstSlideHandler} ${isArrowenable} ${textColor}`}
          data-glide-dir="<">
          {/* needs to change svgs */}

          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16">
            <g fill="none" fillRule="nonzero">
              <path d="M17 20H-7V-4h24z" opacity=".384" />
              <path stroke="" d="M9 16L1 8l8-8" />
            </g>
          </svg>
        </button>
        <button className={`glide__arrow glide__arrow--right ${isArrowenable} ${textColor}`} data-glide-dir=">">
          {/* needs to change svgs */}

          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16">
            <g fill="none" fillRule="nonzero">
              <path d="M-7-4h24v24H-7z" opacity=".384" />
              <path stroke="" d="M1 0l8 8-8 8" />
            </g>
          </svg>
        </button>
      </>
    );
  };
  // navigation
  const getBottomCenterControls = ({ children = [] }, sliderConfigOptions) => {
    const activeSlide = sliderConfigOptions.currentSlide;

    const supportedIndicator = ["dots", "dashes", "none"];
    const indicator = supportedIndicator.includes(slideIndicator) ? `${slideIndicator}` : "";

    return (
      <div className="bottom-center-controls slider-control-bottomcenter">
        {children.map((item, index) => {
          return (
            <button
              key={`slide-button-${index}`}
              className={` ${indicator} ${textColor} ${activeSlide === index ? "is-active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div styleName="glide-wrapper" ref={glideRef} className="glide">
      <div data-glide-el="track" className="glide__track">
        <ul className="glide__slides">{renderChildren(props)}</ul>
      </div>

      <div className="glide__arrows" data-glide-el="controls">
        {arrowNavigation()}
      </div>

      <div data-glide-el="controls[nav]">{getBottomCenterControls(props, sliderConfigOptions, currentSlide)}</div>
    </div>
  );
};
export default GlideBase;

GlideBase.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};
